// 스타일 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import themeHelper from 'src/com/keymansco/chihuahuaone/helper/themeHelper';

// =================================================================================================
// 상수
// =================================================================================================
const style = {
  bg: {
    basic: {
      bg: {
        linearGradient: {
          colors: ['cream500', 'creamPink500'],
          start: [-0.5, 0.2], // 시작점 비율 x, y [0~1]  * 100%
          end: [0.5, -0.2], // 끝점 비율 x, y [0~1]  * 100%
        },
      },
    },
  },
  direction: {
    basic: {
      direction: 'column', // 쌓기 방향 <"row" | "column" | "column-reverse" | "row-reverse">
    },
    reverse: {
      direction: 'column-reverse', // 쌓기 방향 <"row" | "column" | "column-reverse" | "row-reverse">
    },
  },
  font: {
    big: {
      color: themeHelper.colors.hotPink500, // color
      fontSize: themeHelper.fontSizes['6xl'], // font-size
      fontWeight: themeHelper.fontWeights.extrabold,
      letterSpacing: themeHelper.letterSpacings['2xl'],
    },
    label: {
      color: themeHelper.colors.hotPink500, // color
      fontSize: themeHelper.fontSizes['2xl'], // font-size
      fontWeight: themeHelper.fontWeights.semibold,
      letterSpacing: themeHelper.letterSpacings.md,
    },
    title: {
      color: themeHelper.colors.hotPink500, // color
      fontSize: themeHelper.fontSizes['3xl'], // font-size
      fontWeight: themeHelper.fontWeights.extrabold,
      letterSpacing: themeHelper.letterSpacings['2xl'],
    },
    input: {
      bgColor: themeHelper.colors.cream500, // background-color
      color: themeHelper.colors.mildBlack500, // color
      fontSize: themeHelper.fontSizes['3xl'], // font-size
      fontWeight: themeHelper.fontWeights.semibold,
      letterSpacing: themeHelper.letterSpacings.md,
    },
  },
  height: {
    big: {
      base: themeHelper.sizes[12], // breakpoints: 0
      md: themeHelper.sizes[20], // breakpoints: 768
      lg: themeHelper.sizes[20], // breakpoints: 992
    },
  },
  layout: {
    centerFull: {
      alignItems: 'center', // align-items [*align] 항목 가로 정렬 [css 기본 정의에서는 비 기준축 기준 항목 정렬]
      flex: 1, // flex
      justifyContent: 'center', // justify-content [*justify] 항목 기준축(vertical: 세로, horizontal: 가로) 정렬
    },
    centerTop: {
      alignItems: 'center', // align-items [*align] 항목 가로 정렬 [css 기본 정의에서는 비 기준축 기준 항목 정렬]
      flex: 1, // flex
      justifyContent: 'flex-start', // justify-content [*justify] 항목 기준축(vertical: 세로, horizontal: 가로) 정렬
    },
    centerBottom: {
      alignItems: 'center', // align-items [*align] 항목 가로 정렬 [css 기본 정의에서는 비 기준축 기준 항목 정렬]
      flex: undefined, // flex
      justifyContent: 'flex-end', // justify-content [*justify] 항목 기준축(vertical: 세로, horizontal: 가로) 정렬
    },
    center: {
      alignItems: 'center', // align-items [*align] 항목 가로 정렬 [css 기본 정의에서는 비 기준축 기준 항목 정렬]
      justifyContent: 'center', // justify-content [*justify] 항목 기준축(vertical: 세로, horizontal: 가로) 정렬
    },
    full: {
      flex: 1, // flex
    },
    top: {
      alignItems: 'flex-start', // align-items [*align] 항목 가로 정렬 [css 기본 정의에서는 비 기준축 기준 항목 정렬]
      flex: 1, // flex
      justifyContent: 'flex-start', // justify-content [*justify] 항목 기준축(vertical: 세로, horizontal: 가로) 정렬
    },
    // alignSelfCenter: {
    //   alignSelf: 'center',
    // },
  },
  width: {
    screen: {
      base: themeHelper.sizes.full,
      md: themeHelper.sizes['2xl'],
      lg: themeHelper.sizes['2xl'],
    },
  },
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default style;
